<template>
<div class="page">
  <div class="d-flex">
    <div class="col d-flex  flex-column">
      <h1 class="font-sm">Модуль · Ассессмент руководителя</h1>
      <h1 class="font-lg">Управленческие диагностики</h1>
    </div>
    <div class="col d-flex justify-end align-center">
      <div>
        <v-btn
          class="w-100 rounded-lg d-inline-flex"
          max-height="28"
          color="success"
          @click="$router.push('/diagnostic/admin')"
        >
          <template v-slot:default="data">
            <div class="d-flex justify-space-between align-center">
              <div class="font-xs ">Админ-панель</div>
            </div>
          </template>
        </v-btn>
      </div>
    </div>
  </div>

  <div class="col d-flex justify-space-between align-center">
    <div class="font-md text-gray">
      Все ваши диагностики с историей версий черновиков и финальных отчётов.
    </div>
    <div>
      <v-btn
        class="w-100 rounded-lg d-inline-flex"
        max-height="36"
        color="primary"
        @click="newDiagnosticModal = true"
      >
        <template v-slot:default="data">
          <div class="d-flex justify-space-between align-center">
            <v-icon size="16px">
              mdi-plus
            </v-icon>
            <div class="font-sm ">Новая диагностика</div>
          </div>
        </template>
      </v-btn>
    </div>
  </div>
  <DiagnosticsFilters
    v-model="filters.search"
    :status="filters.status"
    :expert="filters.expert"
    :sort="filters.sort"
    :sort-dir="filters.sortDir"
    :counts="statusCounts"
    @update:search="v => { filters.search = v; pagination.page = 1; }"
    @update:status="v => { filters.status = v; pagination.page = 1; }"
    @update:expert="v => filters.expert = v"
    @update:sort="v => filters.sort = v"
    @update:sortDir="v => filters.sortDir = v"
  />
  <DiagnosticsList
    :items="paginatedItems"
    :pagination="computedPagination"
    :loading="checklistsLoading"
    @open="handleOpen"
    @delete="handleDelete"
    @update:perPage="v => { pagination.perPage = v; pagination.page = 1; }"
    @prevPage="pagination.page > 1 && pagination.page--"
    @nextPage="pagination.page < computedPagination.totalPages && pagination.page++"
  />
  <CompetenciesModal
    :value="competenciesModal"
  />
  <NewDiagnosticModal
    v-model="newDiagnosticModal"
    @created="handleCreatedDiagnostic"
  />
  <StatusModal
    :show="notification.show"
    :success="notification.success"
    :message="notification.message"
    @update:show="SET_NOTIFICATION({ show: $event, success: notification.success, message: notification.message })"
  />
</div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import DiagnosticsList from '../../components/Diagnostics/table/DiagnosticsList.vue';
import DiagnosticsFilters from '../../components/Diagnostics/table/DiagnosticsFilters.vue';
import CompetenciesModal from '../../components/Diagnostics/Modal/CompetenciesModal.vue';
import NewDiagnosticModal from '../../components/Diagnostics/Modal/NewDiagnosticModal.vue';
import StatusModal from '../../components/common/StatusModal.vue';

export default {
  name: 'Diagnostic',
  components: {
    CompetenciesModal,
    NewDiagnosticModal,
    DiagnosticsFilters,
    DiagnosticsList,
    StatusModal,
  },
  data() {
    return {
      filters: {
        search: '',
        status: 0,
        expert: 'Все эксперты',
        sort: 'По дате обновления',
        sortDir: 'desc',
      },
      pagination: {
        page: 1,
        perPage: 10,
      },
      newDiagnosticModal: false,
    };
  },

  async mounted() {
    await this.loadChecklists();
  },
  computed: {
    ...mapGetters({
      competenciesModal: 'diagnostics/diagnotics/competenciesModal',
      notification: 'diagnostics/diagnotics/notification',
      checklists: 'diagnostics/diagnotics/checklists',
      checklistsLoading: 'diagnostics/diagnotics/checklistsLoading',
      checklistCandidates: 'diagnostics/diagnotics/checklistCandidates',
    }),

    mappedChecklists() {
      return this.checklists.map(item => {
        const candidate = this.checklistCandidates[item.candidate];
        const fullName = candidate
          ? `${candidate.last_name || ''} ${candidate.first_name || ''}`.trim()
          : '';
        const name = fullName || item.candidate_name || 'Неизвестный участник';
        return {
          id: item.id,
          name,
          company: item.company,
          position: item.position,
          updated: this.formatDate(item.updated_at),
          updatedAt: item.updated_at,
          isDraft: !item.is_locked,
        };
      });
    },

    filteredItems() {
      let items = this.mappedChecklists;
      if (this.filters.search) {
        const s = this.filters.search.toLowerCase();
        items = items.filter(i =>
          i.name.toLowerCase().includes(s) || (i.company && i.company.toLowerCase().includes(s)) || (i.position && i.position.toLowerCase().includes(s)),
        );
      }
      if (this.filters.status === 1) items = items.filter(i => i.isDraft);
      else if (this.filters.status === 2) items = items.filter(i => !i.isDraft);

      const dir = this.filters.sortDir === 'asc' ? 1 : -1;
      const comparators = {
        'По дате обновления': (a, b) => new Date(a.updatedAt || 0) - new Date(b.updatedAt || 0),
        'По имени': (a, b) => a.name.localeCompare(b.name, 'ru'),
        'По статусу': (a, b) => Number(a.isDraft) - Number(b.isDraft),
      };
      const compare = comparators[this.filters.sort] || comparators['По дате обновления'];
      items = [...items].sort((a, b) => dir * compare(a, b));

      return items;
    },

    paginatedItems() {
      const start = (this.pagination.page - 1) * this.pagination.perPage;
      return this.filteredItems.slice(start, start + this.pagination.perPage);
    },

    computedPagination() {
      const total = this.filteredItems.length;
      const totalPages = Math.ceil(total / this.pagination.perPage) || 1;
      const from = total === 0 ? 0 : (this.pagination.page - 1) * this.pagination.perPage + 1;
      const to = Math.min(this.pagination.page * this.pagination.perPage, total);
      return {
 ...this.pagination, total, totalPages, from, to
};
    },

    statusCounts() {
      const all = this.mappedChecklists.length;
      const drafts = this.mappedChecklists.filter(i => i.isDraft).length;
      return { all, drafts, final: all - drafts };
    },
  },
  methods: {
    ...mapMutations({
      SET_NOTIFICATION: 'diagnostics/diagnotics/SET_NOTIFICATION',
    }),
    ...mapActions({
      loadChecklists: 'diagnostics/diagnotics/loadChecklists',
      deleteChecklist: 'diagnostics/diagnotics/deleteChecklist',
    }),

    formatDate(dateStr) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleString('ru-RU', {
        day: '2-digit',
month: '2-digit',
year: 'numeric',
        hour: '2-digit',
minute: '2-digit',
second: '2-digit',
      });
    },

    handleCreatedDiagnostic() {
      this.loadChecklists();
    },
    handleOpen(item) {
      this.$router.push({ name: 'diagnostic-detail', params: { id: item.id } });
    },
    handleDelete(item) {
      this.deleteChecklist(item.id);
    },
  },
};
</script>

<style scoped lang="scss">
$primary-color: #483CB9;
.custom-chip-active {
  background-color: rgba($primary-color, 0.1);
  border: 1px solid rgba($primary-color, 0.4);
  color: $primary-color
}

.custom-search-input {
  .v-input__slot {
    background-color: #f7f7f7;
    border: 1px solid #e0e0e0;
    min-height: 36px;
    border-radius: 6px;
  }

  .v-input__icon--prepend-inner .v-icon {
    color: #9e9e9e;
  }

  input::placeholder {
    color: #a0a0a0;
    font-size: 13px;
  }
}

.custom-select {
  .v-input__slot {
    min-height: 36px;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    background: white
  }

  .v-select__selection {
    font-size: 13px;
  }
}
</style>
